export default __webpack_public_path__ + "static/media/loacker.4a339c89.jpg";